module.exports = __webpack_public_path__ + "static/media/girl03.77982105.png";